export function ipAddressComparator(a?: string, b?: string): number {
	return makeComparableIPAddress(a) - makeComparableIPAddress(b);
}

function makeComparableIPAddress(value?: string): number {
	if (!value) {
		return -Infinity;
	}

	const octets = value.split('.').map(Number);
	if (octets.length !== 4 || octets.some(isNaN)) {
		return -Infinity;
	}

	return octets.reduce((acc, octet) => (acc << 8) | octet, 0);
}
